module.exports = __webpack_public_path__ + "img/Z3RO_2.f11be57b.png";